import posthog from 'posthog-js';

/**
 * Mirrors PUBLIC_SURFACE_SEGMENTS in src/services/api/apiConfig.ts. Duplicated rather
 * than imported because this module is Next's client entry: importing the API layer
 * here would pull it (and its module-level state) into the entry bundle. Keep in sync.
 */
const PUBLIC_SURFACE_SEGMENTS = new Set(['a', 'agent', 's', 'reschedule']);

function isPublicAgentSurface(): boolean {
  const firstSegment = window.location.pathname.split('/').filter(Boolean)[0] ?? '';
  if (firstSegment === 'preview') {
    return new URLSearchParams(window.location.search).has('t');
  }
  return PUBLIC_SURFACE_SEGMENTS.has(firstSegment);
}

const projectToken = process.env.NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN;
const host = process.env.NEXT_PUBLIC_POSTHOG_HOST || 'https://us.i.posthog.com';

if (!projectToken) {
  // Never throw from this module. It runs inside Next's client entry, before hydration,
  // so a throw here aborts the whole client bundle rather than just disabling analytics
  // — it would take down `pnpm dev` and the Playwright suite, neither of which sets the
  // PostHog vars. Warn in every environment, production included: the silent-no-op case
  // is precisely the one nobody notices.
  console.warn(
    '[posthog] NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN is not set — analytics is disabled and every capture() call will no-op.'
  );
} else {
  // Evaluated once per document load. Public agent routes and the Hub are never linked
  // to one another, so a single decision per load holds for the life of the session.
  const isPublic = isPublicAgentSurface();

  posthog.init(projectToken, {
    api_host: host,
    defaults: '2026-01-30',
    debug: process.env.NODE_ENV === 'development',
    // Public agent surfaces carry patient conversations. Explicit capture() calls are
    // the only permitted data source there — nothing may incidentally sweep up DOM
    // text, form input, or exception payloads from a patient session. This is the same
    // boundary PendoProvider (mounted only under (hub)) and the isPublicAgentSurface
    // gate in useUserStore.initialize() already maintain.
    autocapture: !isPublic,
    capture_exceptions: !isPublic,
    disable_session_recording: isPublic,
  });
}
